import { Component, OnInit,NgZone } from '@angular/core';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { Location } from '@angular/common';
@Component({
  selector: 'app-tapnpay-txnsuccess-form',
  templateUrl: './tapnpay-txnsuccess-form.component.html',
  styleUrls: ['./tapnpay-txnsuccess-form.component.scss']
})
export class TapnpayTxnsuccessFormComponent implements OnInit {
  txnDateTime: any;
  txnstatus:any;
  cardNo: any;
  amount: any;
  txnNo: any;
  currency: any;
  CardDetails: any;
  constructor(private router: Router,private location: Location, private ngZone: NgZone) { 
  this.CardDetails = location.getState();
  //   this.txnDateTime="21 Feb 2023, 5:30 PM";
  //   this.txnstatus="SuccessEnd";
  //  this.cardNo="12345678";
  //  this.amount="100.00";
  //  this.txnNo="723456789";

   this.txnDateTime=this.getDate();
    this.txnstatus=this.CardDetails.cardData.txnstatus;
   this.cardNo=this.CardDetails.cardData.cardNo;
   this.amount=this.CardDetails.cardData.amount;
  //  this.txnNo=this.CardDetails.cardData.txnNo;
  this.txnNo=this.CardDetails.cardData.txnNo;
   this.currency=this.CardDetails.cardData.currency;

  }
  getDate(){
    var date = new Date();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var min;
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    min = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + min + ' ' + ampm;
    var month_names = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var day=date.getDate();
    var month=month_names[(date.getMonth()+1) - 1];
    var year=date.getFullYear();
    var finalDate=day+" "+month+" "+year+", "+strTime;
    return finalDate;
  }

  ngOnInit(): void {
    $('.main-header').show();
    $('.footer-dock-menu').hide();
    
  }
  onClose(){
    $('.main-header').show();
    $('.footer-dock-menu').show();
   
    this.ngZone.run(() => {
      this.router.navigate(['/home','cards']);
      });

  }

}
